<template>
	<div>
		<triangle-image
			title="Scopri i nuovi Kit Aperitivo Martini"
		/>

		<div class="container">
			<div class="content">
				<section class="paragraph">
					<h2>
						Cosa sono i kit per fare l’aperitivo in casa
					</h2>
					<p>
						Tutti sogniamo ogni tanto di poter ricreare a casa l’<b>esperienza di un aperitivo autentico</b> come nel nostro bar preferito. Per questo abbiamo realizzato insieme a Martini, lo storico marchio italiano che dal 1863 realizza bevande divenute leggendarie ma sempre attuali, dei kit aperitivo <b>da gustare comodamente a casa</b>, ricchi di gusto e passione.<br>
						Perché continuare a sognare quando potete ordinare subito un kit aperitivo e immergervi nel mondo Martini insieme a noi?
					</p>

					<h2>
						L’abbinamento perfetto tra cocktail e cibo
					</h2>

					<p>
						Ma dunque in cosa consistono questi kit aperitivo? Con ogni <b>kit Aperitivo Martini</b> riceverete a casa tutto l’occorrente per realizzare un cocktail e una ricetta perfetti per il vostro momento speciale a fine giornata o nel weekend. <br>
						Ogni ricetta mira ad esaltare il gusto unico e deciso dei cocktail accompagnandoli ad aromi e ingredienti freschi e delicati. Per esempio con il Kit Americano, troverete nella vostra box le bottiglie di <b>Martini Riserva speciale rubino, Martini riserva speciale bitter</b> e di soda oltre ad arancia e limone freschi per completare il tutto con fette e scorza. In aggiunta a tutto questo ci saranno anche tutti gli ingredienti freschi e dosati per cucinare la ricetta abbinata, insieme ad una comoda scheda ricetta con tutte le istruzioni. Facile no?
					</p>

					<h2>
						Riscopri il piacere dell’aperitivo a casa
					</h2>

					<p>
						Scopri ora le soluzioni pensate per te da Quomi con i <b>Kit Aperitivo Martini</b>. Ogni settimana potrai ordinare una <b>novità da introdurre nella tua cucina</b>, per un’esperienza unica da veri amanti dell’aperitivo.
					</p>
					
					<slick>
						<template slot="slides">
							<div class='recipe' v-for="(item, index) in extras" :key="index">
								<img :src="item.images.big" :alt='item.title'>
								<div class="recipe-name">{{ item.title }}</div>
							</div>
						</template>
					</slick>
				</section>

				<router-link
                    :to="{ name: 'shop' }"
                    class="flex flex-center"
                >
                    <CTA
                    	isStar
                    	color='orange'
                        :content="`Ordina il tuo Kit Aperitivo`"
                    />
                </router-link>	
			</div>
		</div>
	</div>
</template>

<script type="text/javascript">
	import TriangleImage from '../TriangleImage'
	import Slick from '../Slick'
	import { goSlick } from '../../assets/js/slick'

	import { ExtraApi } from '../../api/ExtraApi'

	export default {
	components: {
		TriangleImage,
		Slick
	},

	data () {
		return {
			extras: null,
			extrasId: [3078,3079,3080,3081]
		}
	},

	computed: {
		user () {
			return this.$root.user
		}
	},

	methods: {
		loadExtras () {
			var em = new ExtraApi()
			return em.all({
				params: {
					show: 10,
					page: 1,
					sort_direction: 'asc',
					query: 'id in (' + this.extrasId + ')'
				}
			})

			.then(response => {
				this.extras = response.body.data.resources
			})

			.catch(response => {
			})
		}
	},

	mounted () {
		this.loadExtras()

		.then(response => {
			goSlick()
		})
	}

}
</script>

<style scoped>

.slick-slide >>> .recipe-name.small {
	font-size: 12px;
	text-align: left;
	min-height: 55px;
}

.triangle-image {
	background: url("../../assets/img/covers/martini.jpg");
	background-position: center 8%;
	background-repeat: no-repeat;
	background-size: cover;
}


.content {
	max-width: 800px;
}

.paragraph p {
  margin-bottom: 45px;
}

@media (max-width: 1024px) {
	.triangle-image >>> h1 {
		font-size: 30px;
	}
}

</style>
